import {
    addCallUser,
    delCallUser,
    getChatUserToken,
    postChatAnonymousStart,
    postChatStart,
    sleep
} from "../../services/app";
import React, {useEffect, useRef, useState} from "react";
import {Container, ContainerView, ContainerViewFooter} from "../../components/Container";
import {message} from "antd";
import T from "../../services/language";
import {ChatHeader} from "../Success/Chat/style";
import produce, {current} from "immer";
import Chat, {NoMessagesIcon} from "../Success/Chat";
import {ChatSDK} from "@tencentcloud/chat";
import {initTencentCall, sentCallStateMessage, startCall} from "../Success/Call/tencent";
import Call from "../Success/Call";
import Loading from "../../components/Loading";
import {useParams} from "react-router-dom";
import {createChat} from "../Success/Chat/tencent";
import styled from "styled-components";
import {ButtonSubmit} from "../../components/Button";

export default function AnonymousChat(props) {
    const [loading, setLoading] = useState(false);
    const [thread, setThread] = useState<{
        chatSDK?: ChatSDK;
        callEngine?: any;
        tencentUserId?: string;
        tencentGroupId?: string;
        endChatAt?: string;
        name?: string;
        threadId?: string;
        hidden?: boolean;
        calling?: boolean;
        callInfo?: any;
    }>(null);
    const params: any = useParams(); // { bookingId: string }
    const bookingId = params?.bookingId || "";
    const callRef = useRef<any>(null);
    const [callInvited, setCallInvited] = useState<any>(false);
    const [calling, setCalling] = useState(false);
    const [view, setView] = useState<'history' | 'chat' | 'call'>('chat');
    const timerAutoEndCallRef = useRef<any>({});
    const [restarting, setRestarting] = useState(false);

    useEffect(() => {
        onStart();
    }, [params?.bookingId]);


    const onStart = async () => {
        setLoading(true);
        let chatLocalSession = null;
        let resultStart;
        if (bookingId) {
            resultStart = !!chatLocalSession ? chatLocalSession : (await postChatStart(bookingId))
        } else {
            resultStart = !!chatLocalSession ? chatLocalSession : (await postChatAnonymousStart({}))
        }

        const configLocal: any = {};


        if (resultStart?.status === 200) {
            configLocal.tencentGroupId = resultStart?.data?.data?.tencentGroupId;
            configLocal.tencentUserId = resultStart?.data?.data?.tencentCustomerUserId;
            configLocal.id = resultStart?.data?.data?.id;
            configLocal.endChatAt = resultStart?.data?.data?.endChatAt;
            configLocal.name = resultStart?.data?.data?.name;
            configLocal.threadId = resultStart?.data?.data?.threadId;
            // get token
            await sleep(500); // try to wait for 500ms, tencent delay create account
            const resultToken = await getChatUserToken(bookingId, configLocal.tencentUserId);
            if (resultToken?.status === 200) {
                configLocal.appId = resultToken?.data?.data?.tencentSdkAppId;
                configLocal.token = resultToken?.data?.data?.userSig;

                // start chat
                const chat = await createChat({
                    appId: parseInt(configLocal.appId),
                    userId: configLocal.tencentUserId,
                    userSig: configLocal.token,
                });
                // Init call engine if needed
                const resultCall = await initTencentCall({
                    appId: parseInt(configLocal.appId),
                    userId: configLocal.tencentUserId,
                    userSig: configLocal.token
                });
                console.log({
                    chatSDK: chat,
                    callEngine: resultCall,
                    tencentUserId: configLocal.tencentUserId,
                    tencentGroupId: configLocal.tencentGroupId,
                    endChatAt: configLocal.endChatAt,
                    name: configLocal.name,
                    threadId: configLocal.threadId,
                })
                if (!!chat) {
                    setThread({
                        chatSDK: chat,
                        callEngine: resultCall,
                        tencentUserId: configLocal.tencentUserId,
                        tencentGroupId: configLocal.tencentGroupId,
                        endChatAt: configLocal.endChatAt,
                        name: configLocal.name,
                        threadId: configLocal.threadId,
                    })
                } else {
                    message.error(T("Cannot access chat service!"));
                }
            } else {
                message.error(T("Cannot access chat service!"));
            }


        } else {
            message.error(T("Cannot start chat!"));
        }
        setLoading(false);

    }



    return (
        <Container style={{backgroundColor: "#fff"}}>
            {loading ? <Loading/> : null}


            {
                !!thread ? (
                    <div style={{position: 'relative'}}>
                        <Chat
                            isEndedChat={!!thread?.endChatAt}
                            bookingId={bookingId}
                            tencentGroupId={thread.tencentGroupId}
                            mode={'customer'}
                            tencentUserId={thread.tencentUserId}
                            chatSDK={thread.chatSDK}
                            threadId={thread.threadId}
                            name={thread?.name}
                            callInvited={callInvited}
                            onAcceptInviteCall={() => {
                                callRef.current.onAcceptInviteCall({
                                    ...callInvited,
                                    groupID: thread.tencentGroupId,
                                });
                                setCallInvited(false);
                            }}
                            header={(<ChatHeader
                                view={view}
                                callType={thread?.callInfo?.callType}
                                setView={setView}
                                calling={!!calling}
                                name={(thread?.name || "")}
                                />)}
                            onMessage={(eventName, beMessage) => {
                                if (eventName === 'END-CHAT' && thread?.tencentGroupId === beMessage?.tencentGroupId) {
                                    // Destroy chat sdk
                                    try {
                                        if (!!thread?.chatSDK) {
                                            thread?.chatSDK?.destroy?.();
                                        }
                                        if (thread?.callEngine) {
                                            thread?.callEngine?.destroy?.();
                                        }
                                    } catch (e) {
                                    }
                                    setThread(null);
                                    message.destroy();
                                }
                                if (eventName === 'MESSAGE') {
                                    // setThread(produce((draft: any) => {
                                    //     const currentThead = current(draft);
                                    //     if (!!currentThead?.hidden && currentThead?.tencentGroupId === beMessage?.tencentGroupId) {
                                    //         draft.hidden = false;
                                    //     }
                                    // }))
                                }
                            }}
                        />

                        <Call
                            view={view}
                            user={{
                                fullName: T("Customer"),
                                avatar: "",
                                userName: thread.tencentUserId
                            }}
                            ref={callRef}
                            callEngine={thread?.callEngine}
                            onInvite={(event) => {
                                console.log("onInvite", event);
                                // Check if the call in group
                                if (event?.groupID === thread.tencentGroupId) {
                                    setCallInvited(event);
                                } else {
                                    callRef?.current?.endCall();
                                }
                            }}
                            onUserLeave={(userID) => {
                                console.log("onUserLeave", userID);
                                setThread(produce((draft: any) => {
                                    const currentThead = current(draft);
                                    delCallUser(currentThead?.threadId, userID).finally(() => {
                                    });
                                }))
                            }}
                            onStartCall={(callInfo) => {
                                setView('call');
                                addCallUser(thread?.threadId, thread?.tencentUserId).finally(() => {
                                    sentCallStateMessage(thread?.chatSDK, thread?.tencentGroupId, {
                                        tencentUserId: thread?.tencentUserId,
                                        bookingId: bookingId,
                                        tencentGroupId: thread?.tencentGroupId,
                                        threadId: thread?.threadId,
                                        name: thread?.name || "",
                                        isCalling: false,
                                    }, "CALL-JOIN-STATE").then()
                                });
                            }}
                            onEndCall={() => {
                                setCallInvited(false);
                                setThread(produce((draft: any) => {
                                    const currentThead = current(draft);
                                    delCallUser(currentThead?.threadId, currentThead?.tencentUserId).finally(() => {
                                        sentCallStateMessage(currentThead?.chatSDK, currentThead?.tencentGroupId, {
                                            tencentUserId: currentThead?.tencentUserId,
                                            bookingId: bookingId,
                                            tencentGroupId: currentThead?.tencentGroupId,
                                            threadId: currentThead?.threadId,
                                            name: currentThead?.name || "",
                                            isCalling: false,
                                        }, "CALL-LEAVE-STATE").then()
                                    });
                                }))
                                if (timerAutoEndCallRef?.current?.timer) {
                                    clearTimeout(timerAutoEndCallRef.current.timer);
                                }
                                timerAutoEndCallRef.current = {
                                    timer: null,
                                    roomID: null,
                                };
                            }}
                            onChange={(calling, callInfo) => {
                                console.log('onChange', calling, callInfo);
                                if (!calling && !!callInvited) {
                                    setCallInvited(false);
                                }
                                setThread(produce((draft: any) => {
                                    draft.calling = calling;
                                    draft.callInfo = callInfo;
                                }))
                                setCalling(calling);
                            }}
                            mode={'customer'}
                        />
                    </div>
                ) : (
                    <EndedOverlay>
                        <NoMessagesIcon style={{width: 218, height: 169}}/>
                        <EndedTitle>{T("Hello there,\n" +
                            "How could we help you today?")}</EndedTitle>
                        <EndedButton
                            loading={restarting || loading}
                            onClick={async () => {
                                if (restarting || loading) return;
                                setRestarting(true);
                                try {
                                    await onStart();
                                } finally {
                                    setRestarting(false);
                                }
                            }}
                            icon={<Icon/>}
                        >
                            <span style={{marginLeft: 9}}>{T("Chat With Us")}</span>
                        </EndedButton>
                    </EndedOverlay>
                )
            }
        </Container>
    );
}

const EndedOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
`;

const EndedTitle = styled.div`
    margin-top: 12px;
    font-size: 16px;
    font-weight: 600;
    color: #494949;
    text-align: center;
    white-space: pre-line;
`;

const EndedButton = styled(ButtonSubmit)`
    margin-top: 16px !important;
    width: auto;
    padding: 0 20px;
`;

const Icon = (props) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.8333 2.33301H8.16665C4.94665 2.33301 2.33331 4.93467 2.33331 8.14301V15.1197V16.2863C2.33331 19.4947 4.94665 22.0963 8.16665 22.0963H9.91665C10.2316 22.0963 10.6516 22.3063 10.85 22.563L12.6 24.8847C13.37 25.9113 14.63 25.9113 15.4 24.8847L17.15 22.563C17.3716 22.2713 17.7216 22.0963 18.0833 22.0963H19.8333C23.0533 22.0963 25.6666 19.4947 25.6666 16.2863V8.14301C25.6666 4.93467 23.0533 2.33301 19.8333 2.33301ZM15.1666 16.0413H8.16665C7.68831 16.0413 7.29165 15.6447 7.29165 15.1663C7.29165 14.688 7.68831 14.2913 8.16665 14.2913H15.1666C15.645 14.2913 16.0416 14.688 16.0416 15.1663C16.0416 15.6447 15.645 16.0413 15.1666 16.0413ZM19.8333 10.208H8.16665C7.68831 10.208 7.29165 9.81134 7.29165 9.33301C7.29165 8.85467 7.68831 8.45801 8.16665 8.45801H19.8333C20.3116 8.45801 20.7083 8.85467 20.7083 9.33301C20.7083 9.81134 20.3116 10.208 19.8333 10.208Z"
            fill="#FFF"/>
    </svg>
)
